// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – a JELEN/JÖVŐ (.panel--future) panel dinamikája.
 *
 * Visszaszámlál az újraindulás időpontjáig (LAUNCH), másodpercenként
 * frissítve a nap/óra/perc/mp értékeket. A célidő elérésekor „élő"
 * állapotra vált és leállítja az időzítőt.
 *
 * Az indulási időpont a LAUNCH konstansban állítható át.
 * Nincs külső függőség, nincs build; klasszikus <script>-ként fut.
 */

// Az újraindulás célidőpontja – ezt átírva állítható a visszaszámlálás.
const LAUNCH = new Date('2026-07-24T00:00:00');

function initFuture() {
  // Visszaszámlálás.
  const countdown = document.getElementById('countdown');
  const daysEl = document.getElementById('cd-days');
  const hoursEl = document.getElementById('cd-hours');
  const minsEl = document.getElementById('cd-mins');
  const secsEl = document.getElementById('cd-secs');

  if (daysEl === null || hoursEl === null || minsEl === null || secsEl === null) {
    return;
  }

  const pad = (value) => `${value}`.padStart(2, '0');

  const tick = () => {
    const diff = LAUNCH.getTime() - new Date().getTime();

    // Elérkezett (vagy elmúlt) az indulás: „élő" állapot, nullázott számok.
    if (diff <= 0) {
      if (countdown !== null) {
        countdown.dataset.state = 'live';
      }
      daysEl.textContent = '0';
      hoursEl.textContent = '00';
      minsEl.textContent = '00';
      secsEl.textContent = '00';
      return false;
    }

    const totalSeconds = Math.floor(diff / 1000);
    daysEl.textContent = `${Math.floor(totalSeconds / 86400)}`;
    hoursEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
    minsEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
    secsEl.textContent = pad(totalSeconds % 60);
    return true;
  };

  // Azonnali első kirajzolás, majd másodpercenkénti frissítés.
  if (tick() === true) {
    const timer = window.setInterval(() => {
      if (tick() === false) {
        window.clearInterval(timer);
      }
    }, 1000);
  }
}

initFuture();
